import {
    GetAS2MessageEndpointInput,
    GetAS2MessageEndpointOutput,
    UpdateAS2MessageEndpointInput,
    UpdateAS2MessageEndpointOutput,
} from '../types/certificate';
import { Logger } from '../utils/logger';
import { HrpsApiClient } from './HrpsApiClient';

export const getAS2MessageEndpoint = async (
    input: GetAS2MessageEndpointInput
): Promise<GetAS2MessageEndpointOutput> => {
    Logger.info('Getting AS2 Message Endpoint', input);
    return await new HrpsApiClient()
        .callHrps('getAS2MessageEndpoint', input)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            Logger.error('Error getting AS2 message endpoint: ', error.message);
            throw error;
        });
};

export const updateAS2MessageEndpoint = async (
    input: UpdateAS2MessageEndpointInput
): Promise<UpdateAS2MessageEndpointOutput> => {
    Logger.info('Updating AS2 Message Endpoint', input);
    return await new HrpsApiClient()
        .callHrps('updateAS2MessageEndpoint', input)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            Logger.error('Error updating AS2 message endpoint: ', error.message);
            throw error;
        });
};
